"use client";

import { useEffect, useRef, useState } from "react";

import { useDeskMonitor } from "../DeskMonitor";
import { formatClock } from "../timeline";

/**
 * The call's recording clock. It starts with the people monitor, as the
 * caption does, and keeps the call's time from then on: it updates only while
 * the monitor is playing, and reads the time that has really passed whenever
 * it does.
 */
export default function RecordingClock({ startSeconds }: { startSeconds: number }) {
  const { isPlaying } = useDeskMonitor();
  const startedAtRef = useRef<number | null>(null);
  const [elapsedSeconds, setElapsedSeconds] = useState(0);

  useEffect(() => {
    if (!isPlaying) {
      return;
    }

    startedAtRef.current ??= performance.now();

    const startedAt = startedAtRef.current;
    let timer: number | undefined;

    // Each tick lands on the next whole second since the start.
    function scheduleTick() {
      const elapsedMs = performance.now() - startedAt;

      timer = window.setTimeout(
        () => {
          setElapsedSeconds(Math.floor((performance.now() - startedAt) / 1000));
          scheduleTick();
        },
        1000 - (elapsedMs % 1000),
      );
    }

    scheduleTick();

    return () => window.clearTimeout(timer);
  }, [isPlaying]);

  return <>REC {formatClock(startSeconds + elapsedSeconds)}</>;
}
